import React, {useState} from 'react';
import {useLocation} from 'react-router-dom';

function NavBar(props) {
  const location = useLocation();
  // const [activeTab, setActiveTab] = useState('/');
  // const toggle = tab => {
  //     if (activeTab !== tab) setActiveTab(tab);
  // }

  const returnActiveClassByPath = path => {
    if (location.pathname === path || location.pathname === (path + '/')) {
      return 'active';
    } else {
      return null;
    }
  }

  return (
    <>
    <div className="top-bar-area">
        <div className="container">
            <div className="row align-center">
                <div className="col-lg-3 logo">
                    <a href="/">
                        <img src={require("../img/logo.png")} className="logo" alt="Logo" />
                    </a>
                </div>
                <div className="col-lg-9 address-info text-right">
                    <div className="info box">
                        <ul>
                            <li>
                                <div className="icon">
                                    <i className="flaticon-email"></i>
                                </div>
                                <div className="info">
                                    <span>Email</span><a href = "mailto:divine@divinechpstaffing.com">divine@divinechpstaffing.com</a>
                                    <br />
                                    <p style={{visibility: 'hidden'}}>Contact Us</p>
                                </div>
                            </li>
                            <li>
                                <div className="icon">
                                    <i className="flaticon-call"></i>
                                </div>
                                <div className="info">
                                    <span>Phone</span><a href="tel:9199721964">919 972 1964</a>
                                    <br />Fax: 984 465 0694
                                </div>
                            </li>
                            <li>
                                <div className="icon">
                                    <i className="flaticon-clock-1"></i>
                                </div>
                                <div className="info">
                                    <span>Office Hours</span> Mon - Fri : 8:00am - 4:30pm
              									<br /> Sat : 9:00am - 2:00pm
                                </div> 
                            </li>
              							{/*<li>
              							    <div>
                                    <div className="item-flex">
                                        <a className="button" href="#booking">Contact Us</a>
                                     </div>
                                </div>
                            </li>*/}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <header>
        <div className="container box-nav">
            <div className="row">
                <nav id="mainNav" className="navbar logo-less top-less navbar-default navbar-fixed white bootsnav on no-full nav-box no-background">
                    
                    <div className="container">
                        <div className="attr-nav contact">
                            <ul>
                                <li>
                                    <i className="fas fa-stethoscope"></i>
                                    <p>
                                        Phone Number <a href="tel:9199721964">919 972 1964</a>
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle mr-2" data-toggle="collapse" data-target="#navbar-menu">
                                <i className="fa fa-bars"></i>
                            </button>
                            <a className="navbar-brand" href="/"><img src={require("../img/logo.png")} className="logo" alt="Logo" /></a>
                        </div>

                        <div className="collapse navbar-collapse" id="navbar-menu">
                            <ul className="nav navbar-nav navbar-left" data-in="fadeInDown" data-out="fadeOutUp">
                              <li className="dropdown">
                                  <a href="/" className={returnActiveClassByPath('/')}>Home</a>
                              </li>
                              <li className="dropdown">
                                  <a href="clients" className={returnActiveClassByPath('/clients')}>Clients</a>
        					            </li>

                              {/*<li className="dropdown">
                                  <a href="#" className="dropdown-toggle" data-toggle="dropdown" >Services</a>
                                  <ul className="dropdown-menu">
                                      <li><a href="services">Placements</a></li>
                                      <li><a href="services">Staffing</a></li>
                                      
                                  </ul>
                              </li>*/}
        			                <li>
                                <a href="careers" className={returnActiveClassByPath('/careers')}>Careers</a>
                              </li>

        					            <li>
                                <a href="employees" className={returnActiveClassByPath('/employees')}>Our Employees</a>
                              </li>

                              <li>
                                  <a href="contact" className={returnActiveClassByPath('/contact')}>Contact Us</a>
                              </li>
                            </ul>
                        </div>
                    </div>   
                </nav>

                <div className="clearfix"></div>
            </div>
        </div>
    </header>
    </>
  );
}

export default NavBar;